import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-double-preview',
    templateUrl: './modal-double-preview.component.html',
    styleUrls: ['./modal-double-preview.component.scss'],
    standalone: false
})
export class ModalDoublePreviewComponent implements OnInit {
  balancesCero: boolean = false;
  contadoresCero: boolean = false;
  btnStatus: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ModalDoublePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    //This is intentional
  }

  onNoClick(): void {
    const res = {
      status: false,
    }
    this.dialogRef.close(res);
  }

  onSubmit(): void {
    const res = {
      status: true,
      balancesCero: this.balancesCero,
      contadoresCero: this.contadoresCero
    }
    this.dialogRef.close(res);
  }

  addValue(data) {
    console.log('data', data);
    this.btnStatus = (data === "");
  }

}
